import { all, fork } from "redux-saga/effects";

import { fileTagsSaga } from "./component/FileTags/store/saga";
import { formLayoutsSaga } from "./component/FormLayouts/store/saga";
import { importsSaga } from "./component/Imports/store/saga";
import { manageFieldsSaga } from "./component/ManageFields/store/saga";
import { mergeDuplicatesSaga } from "./component/MergeDuplicates/store/saga";
import { organizationDetailsSaga } from "./component/OrganizationDetails/store/saga";
import { restorableRecordsSaga } from "./component/RestorableRecords/store/saga";
import { sandboxSaga } from "./component/Sandbox/store/saga";
import { sessionsSaga } from "./component/Sessions/store/saga";

export function* settingsSaga() {
  yield all([fork(mergeDuplicatesSaga)]);
  yield all([fork(manageFieldsSaga)]);
  yield all([fork(formLayoutsSaga)]);
  yield all([fork(sandboxSaga)]);
  yield all([fork(importsSaga)]);
  yield all([fork(restorableRecordsSaga)]);
  yield all([fork(fileTagsSaga)]);
  yield all([fork(sessionsSaga)]);
  yield all([fork(organizationDetailsSaga)]);
}
